import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  DoBetting,
  ClearBetStore,
  CancelBetting,
  RemoveOneBet
} from "../../common/actions/betAction";
import { DoMiniBetting, ClearMiniBetStore } from "../../common/actions/miniAction";
import { GetBettingHistories } from '../../common/actions/moreAction';
import {
  fixedNumber,
  isEmpty,
  isMobilePage,
  toastr,
  getBetCard,
  getMarketRate,
  no_comma
} from "../../common/cores";
import BettingInfo from "./sportscomponent/BettingInfo";
import store from "../../common/store";
import { ADD_ONEBET } from "../../common/actions/types";
import { RemoveLocal } from "../../utils";
// import { resource_url } from '../../common/cores/keys';

const SportsRight = props => {
  const { type, user, minigame, bet, userdata, levelBettingData, pageInfo, bet_setting } = props;
  const betList = props.bet.bettedItems;
  const userLevel = isNaN(Number(userdata.level)) ? 1 : Number(userdata.level);
  // console.log(props)
  useEffect(() => {
    if(type == "virtual")
    {
      let deleteList = []
      if (betList.length > 0) {
  
        betList.forEach(item => {
          const selectIndex = sportsList.findIndex(list => list.key == item.eventKey)
          if (selectIndex < 0) {
            deleteList.push(item.betId)
          }
        })
        deleteList.forEach(delItem => {
          remove(delItem);
        })
      }
    }
  }, [sportsList])

  useEffect(() => {
    if (!isEmpty(betList)) {
      localStorage.setItem("bettingItem", JSON.stringify(betList));
    }
  }, [betList])

   useEffect(() => {
    setTimeout(() =>{
      const localStorageBetItem = JSON.parse(localStorage.getItem("bettingItem"));
      const localStorageEventKey = localStorage.getItem("eventkey");
      const localStorageSportsId = localStorage.getItem("sportsId");
      if (!isEmpty(localStorageBetItem)) {
        store.dispatch({
          type: ADD_ONEBET,
          payload: {
            sportId: localStorageSportsId,
            eventKey: localStorageEventKey,
            bettedItems: localStorageBetItem,
            multiBetting: {}
          }
        })
      }
    }, 500)
  }, [])
 
  useEffect(() => {
    return(() => {
      removeAll();
    })
  }, [])
  const [betRate, setBetRate] = useState(fixedNumber(1));
  const [money, setMoney] = useState(0);
  const [popup, setPopup] = useState(false);
  const [showCard, setShowCard] = useState(false);

  const [maxMoney, setMaxMoney] = useState(0);
  const [minMoney, setMinMoney] = useState(0);
  const [maxGet, setGetMoney] = useState(0);
  const [multiFoldMsg, setMultiFoldMsg] = useState("");
  const [nonMultiFoldMsg, setNonMultiFoldMsg] = useState("");
  const [betPanel, setBetPanel] = useState(false);
  const [histories, setHistories] = useState([]);

  useEffect(() => {
    setHistories(props.histories)
  }, [props.histories])

  const GetBettingHistories = (page, type, clear = false) => {
    if (isEmpty(type)) type = "prematch";
    if (props.user.isAuthenticated) {

      // props.GetBettingHistories({
      //   type,
      //   page,
      //   perPage: 10,
      //   gameResult: "",
      //   clear: clear
      // })
    }

  }

  const onSetMoney = value => {
    let currentMoney = Math.floor(userdata.balance.money)
    let resultMoney = Math.floor(maxGet / fixedNumber(betRate))
    if (value === "max") {
      if (type !== "minigame") {
        if (type !== "virtual") {
          if (betList.length === 1) {
            value = Math.min(currentMoney, resultMoney, levelBettingData[userLevel - 1][`${pageInfo.gameType}SingleMax`])
          } else {
            value = Math.min(currentMoney, resultMoney, levelBettingData[userLevel - 1][`${pageInfo.gameType}MultiMax`])
          }
        } else {
          value = Math.min(currentMoney, resultMoney, levelBettingData[userLevel - 1][`betSingleMax`])
        }
      } else {
        value = Math.min(currentMoney, resultMoney, levelBettingData[userLevel - 1][`miniSingleMax`])
      }
      return setMoney(value);
    } else {
      setMoney(money + value);
    }
  };
  useEffect(
    () => {
      let maxbetMoney = 0;
      let minbetMoney = 0;
      let maxMoney = 0;
      if (isEmpty(levelBettingData) || isEmpty(levelBettingData[userLevel - 1])) {
        return;
      } else {
        if (type !== "minigame") {
          if (type !== "virtual") {
            if (betList.length > 1) {
              minbetMoney =
                levelBettingData[userLevel - 1][`${pageInfo.gameType}MultiMin`];
              maxbetMoney =
                levelBettingData[userLevel - 1][`${pageInfo.gameType}MultiMax`];
              maxMoney =
                levelBettingData[userLevel - 1][
                `${pageInfo.gameType}WinMultiMax`
                ];
            }
            else {
              minbetMoney =
                levelBettingData[userLevel - 1][`${pageInfo.gameType}SingleMin`];
              maxbetMoney =
                levelBettingData[userLevel - 1][`${pageInfo.gameType}SingleMax`];
              maxMoney =
                levelBettingData[userLevel - 1][
                `${pageInfo.gameType}WinSingleMax`
                ];
            }
          } else {
            maxbetMoney = levelBettingData[userLevel - 1][`betSingleMax`];
            minbetMoney = levelBettingData[userLevel - 1][`betSingleMin`];
            maxMoney = levelBettingData[userLevel - 1][`betWinSingleMax`];
          }
        } else {
          maxbetMoney = levelBettingData[userLevel - 1][`miniSingleMax`];
          minbetMoney = levelBettingData[userLevel - 1][`miniSingleMin`];
          maxMoney = levelBettingData[userLevel - 1][`miniWinSingleMax`];
        }
      }

      setMaxMoney(maxbetMoney);
      setMinMoney(minbetMoney);
      setGetMoney(maxMoney);
    },
    [type, levelBettingData, pageInfo.gameType, betList]
  );

  const remove = betId => {
    props.RemoveOneBet(betId);
  };

  const removeAll = () => {
    RemoveLocal();
    props.ClearMiniBetStore();
    props.ClearBetStore();
  };

  const onBetting = () => {
    setPopup(!popup);
  };

  const onChange = e => {
    if (!isNaN(Number(no_comma(e.target.value))))
      setMoney(Number(no_comma(e.target.value)));
    else setMoney(0);
  };

  const onReset = () => {
    setMoney(0);
  };

  // betList.forEach(element => {
  //     setBetRate(betRate * element.price);
  // });
  // let betList = [];
  // console.log(betList)
  // debugger
  const sportsList = props.sportsList;
  // console.log(sportsList);

  const DoBetting = () => {
    setPopup(!popup);
    if (!props.isAuthenticated) {
      return toastr.warning("로그인하시고 이용해주세요.");
    }
    if (isEmpty(money) || money === 0) {
      return toastr.warning("머니를 선택해주세요.");
    }
    if (type !== "minigame" && isEmpty(betList)) {
      return toastr.warning("배팅을 선택해주세요.");
    }
    if (type === "minigame" && isEmpty(props.minigame.data)) {
      return toastr.warning("배팅을 선택해주세요.");
    }
    setMoney(0);
    setBetRate(1);

    // const userLevel = isNaN(Number(user.level)) ? 1 : Number(user.level);
    let betavailbleMessage = "";

    if (
      isEmpty(type) ||
      isEmpty(levelBettingData) ||
      isEmpty(levelBettingData[userLevel - 1])
    ) {
      return;
    } else {
      if (type !== "minigame") {
        if (type !== "virtual") {
          if (betList.length === 1) {
            const maxbetMoney =
              levelBettingData[userLevel - 1][`${pageInfo.gameType}SingleMax`];
            const minbetMoney =
              levelBettingData[userLevel - 1][`${pageInfo.gameType}SingleMin`];
            if (money < minbetMoney)
              betavailbleMessage = "제한된 배팅금액보다 작게 배팅하셨습니다.";
            if (money > maxbetMoney)
              betavailbleMessage = "제한된 배팅금액보다 많게 배팅하셨습니다. ";
          } else {
            betList.forEach(list => {
              // const leaguelevel = isNaN(Number(list.Fixture.League.level)) || Number(list.Fixture.League.level) === 0  ? 1 : Number(list.Fixture.League.level);
              if (isEmpty(levelBettingData)) return;
              // const maxLevelbetMoney = levelBettingData[userLevel - 1][`${pageInfo.gameType}League${leaguelevel}`]
              const maxbetMoney =
                levelBettingData[userLevel - 1][`${pageInfo.gameType}MultiMax`];
              const minbetMoney =
                levelBettingData[userLevel - 1][`${pageInfo.gameType}MultiMin`];
              if (money < minbetMoney)
                return (betavailbleMessage =
                  "제한된 배팅금액보다 작게 배팅하셨습니다.");
              if (money > maxbetMoney)
                return (betavailbleMessage =
                  "제한된 배팅금액보다 많게 배팅하셨습니다. ");
            });
          }
        } else {
          const maxbetMoney = levelBettingData[userLevel - 1][`betSingleMax`];
          const minbetMoney = levelBettingData[userLevel - 1][`betSingleMin`];
          if (money < minbetMoney)
            betavailbleMessage = "제한된 배팅금액보다 작게 배팅하셨습니다.";
          if (money > maxbetMoney)
            betavailbleMessage = "제한된 배팅금액보다 많게 배팅하셨습니다. ";
        }
        if (!isEmpty(betavailbleMessage)) return toastr.warning(betavailbleMessage); {
          setMoney(0);
          setBetRate(1);
          props.DoBetting(money, type);
        }
      } else {
        const maxbetMoney = levelBettingData[userLevel - 1][`miniSingleMax`];
        const minbetMoney = levelBettingData[userLevel - 1][`miniSingleMin`];
        if (money < minbetMoney)
          betavailbleMessage = "제한된 배팅금액보다 작게 배팅하셨습니다.";
        if (money > maxbetMoney)
          betavailbleMessage = "제한된 배팅금액보다 많게 배팅하셨습니다. ";

        if (!isEmpty(betavailbleMessage))
          return toastr.warning(betavailbleMessage);

        setMoney(0);
        setBetRate(1);
        props.DoMiniBetting(money, type);
      }
    }
  };


  useEffect(
    () => {
      if (type === "minigame") return;
      let price = 1;
      let bonusRate = 1;
      if (type === "virtual") {
        betList.forEach(element => {
          price = price * getMarketRate(element);
        });
      } else {
        let betLength = betList.length;
        let isBonus = false;
        betList.forEach(element => {
          let card = getBetCard(element, type);
          // //console.log( getBetCard(element, type), card)
          if (Number(card.rate) < 1.3) {
            betLength--;
          }
          price = price * Number(card.rate);
          if (price > Number(bet.maxBetRate)) price = Number(bet.maxBetRate);
          // //console.log(price)
        });

        bet_setting.forEach(setting => {
          if (betLength >= Number(setting.fold)) {
            setMultiFoldMsg(
              `${setting.fold}폴더 보너스 배당이 ${setting.value
              }배 적용되었습니다. `
            );
            isBonus = true;
            bonusRate = Number(setting.value);
          }
        });

        if (!isBonus) {
          setMultiFoldMsg("");
        }

        if (betLength !== betList.length) {
          setNonMultiFoldMsg("1.3 이하의 배당율은 폴더로 인정되지 않습니다.");
        } else {
          setNonMultiFoldMsg("");
        }
      }
      setBetRate(price * bonusRate);
    },
    [betList.length]
  );

  useEffect(
    () => {
      let price = 1;
      price = price * Number(props.minigame.data.rate);
      setBetRate(price);
    },
    [props.minigame.data.odd_key]
  );
  useEffect(() => {
    GetBettingHistories(1, type, true);
  }, [betPanel]);
  const onShowCard = () => {
    setShowCard(!showCard);
  };

  return (
    <Fragment>
      <div
        className="contents_box_right sports_cart_wrap_wrap bettingCard"
        style={{ display: showCard ? "block" : "" }}
      >
        <div
          className="modal-back"
          onClick={() => onShowCard()}
          style={{ display: showCard ? "" : "none" }}
        />
        <div className="sports_cart_wrap">
          <div className="sports_cart_close">
            <a className="cart_close" onClick={() => onShowCard()}>
              <img src="../images/m_close.png" width="50" alt="" />
            </a>
          </div>
          <div className="sports_cart_title">BETTING SLIP</div>
          <div className="sports_cart_wrap">
            <div className="con_box00">
              <table
                width="100%"
                border="0"
                align="center"
                cellSpacing="0"
                cellPadding="0"
              >
                <tbody>
                  <tr>
                    <td className="sports_cart_style1">
                      보유머니
                      <span className="sports_cart_style3">
                        {!isEmpty(userdata.balance)
                          ? Number(userdata.balance.money).toLocaleString()
                          : "0"}
                      </span>
                    </td>
                  </tr>
                  {/* <tr>
                                        <td className="sports_cart_style1">최대베팅금 <span className="sports_cart_style3">50.000,000</span></td>
                                    </tr>
                                    <tr>
                                        <td className="sports_cart_style1">최대적중금 <span className="sports_cart_style3">100.000,000</span></td>
                                    </tr> */}
                </tbody>
              </table>
            </div>
          </div>
          {type !== "minigame" ? (
            betList.map((list, index) => {
              // setBetRate(betRate * list.price); type !== "virtual" ? "betgame365" : type
              // console.log(list);
              let betCard = getBetCard(list, type);
              // console.log(betCard);
              return (
                <div
                  data-v-ee85aa0c=""
                  className="bet-list-item column"
                  key={index}
                >
                  <div className="sports_cart_bet">
                    <table
                      width="100%"
                      border="0"
                      align="center"
                      cellPadding="0"
                      cellSpacing="0"
                      className="cart_bet"
                    >
                      <tbody>
                        {/* { type === "virtual" && <tr>
                                            <td colSpan="2"><span className="sports_cart_bet_font2">{betCard.leagueName}</span></td>
                                        </tr>} */}
                        <tr>
                          <td colSpan="2">
                            <span className="sports_cart_bet_font2">
                              {betCard.leagueName}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2">
                            <span className="sports_cart_bet_font1">
                              {betCard.homeTeam} vs {betCard.awayTeam}
                            </span>
                          </td>
                          <td rowSpan="3">
                            <a onClick={() => remove(list.betId)}>
                              <img
                                src="../images/cart_close.png"
                                style={{ padding: "0 3px" }}
                                alt=""
                              />
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2">
                            <span className="sports_cart_bet_font2">
                              {betCard.marketName}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2">
                            <span className="sports_cart_bet_font3">
                              {betCard.marketDetail}
                              {betCard.baseline}
                            </span>
                            <span className="sports_cart_bet_p">
                              {betCard.rate}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="sports_cart_bet">
              <table
                width="100%"
                border="0"
                align="center"
                cellPadding="0"
                cellSpacing="0"
                className="cart_bet"
              >
                <tbody>
                  <tr>
                    <td style={{ height: "300px", textAlign: "center" }}>
                      <span className="sports_cart_bet_font2">
                        {props.minigame.data.name}
                        <br />
                        {props.minigame.data.rate}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          {betList.length === 0 && type !== "minigame" && (
            <div className="sports_cart_bet">
              <table
                width="100%"
                border="0"
                align="center"
                cellPadding="0"
                cellSpacing="0"
                className="cart_bet"
              >
                <tbody>
                  <tr>
                    <td style={{ height: "300px", textAlign: "center" }}>
                      <span className="sports_cart_bet_font2">
                        베팅카트가 비어있습니다
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          <div className="sports_cart_wrap">
            <div className="con_box00">
              <table
                width="100%"
                border="0"
                align="center"
                cellSpacing="0"
                cellPadding="0"
              >
                <tbody>
                  {
                    !isEmpty(multiFoldMsg) && 
                    <BettingInfo label={multiFoldMsg} value={""} />
                  }
                  {
                    !isEmpty(nonMultiFoldMsg) && 
                    <BettingInfo label={nonMultiFoldMsg} value={""} />
                  }
                  <BettingInfo label="배당률" value={fixedNumber(betRate)} />
                  <BettingInfo
                    label="당첨예상금"
                    value={Number(
                      money * fixedNumber(betRate)
                    ).toLocaleString()}
                  />
                  <BettingInfo
                    label="최소 배팅금액"
                    value={minMoney.toLocaleString()}
                  />
                  <BettingInfo
                    label="최대 배팅금액"
                    value={maxMoney.toLocaleString()}
                  />
                  {/* {type !== "virtual" && type !== "minigame" && (
                    <BettingInfo
                      label="최대 당첨금액"
                      value={maxGet.toLocaleString()}
                    />
                  )} */}
                  {/* <tr>
                        <td className="sports_cart_style1">보너스배당률 <span className="sports_cart_style2">0.00</span></td>
                    </tr>
                    <tr>
                        <td className="sports_cart_style1">총 배당률 <span className="sports_cart_style2">{fixedNumber(betRate)}</span></td>
                    </tr> */}
                  <tr>
                    <td className="sports_cart_style1">
                      <input
                        className="sports_input1"
                        placeholder="베팅금액"
                        inputMode="numeric"
                        onChange={onChange}
                        value={
                          Number(money).toLocaleString() == 0
                            ? ""
                            : Number(money).toLocaleString()
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="con_box00">
              <table
                width="100%"
                border="0"
                align="center"
                cellSpacing="4"
                cellPadding="0"
              >
                <tbody>
                  <tr>
                    <td width="33.3333%" align="center">
                      <a>
                        <span
                          className="sports_btn2"
                          onClick={() => onSetMoney(5000)}
                        >
                          5천원
                        </span>
                      </a>
                    </td>
                    <td width="33.3333%" align="center">
                      <a>
                        <span
                          className="sports_btn2"
                          onClick={() => onSetMoney(10000)}
                        >
                          1만원
                        </span>
                      </a>
                    </td>
                    <td width="33.3333%" align="center">
                      <a>
                        <span
                          className="sports_btn2"
                          onClick={() => onSetMoney(50000)}
                        >
                          5만원
                        </span>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td width="33.3333%" align="center">
                      <a>
                        <span
                          className="sports_btn2"
                          onClick={() => onSetMoney(100000)}
                        >
                          10만원
                        </span>
                      </a>
                    </td>
                    <td width="33.3333%" align="center">
                      <a>
                        <span
                          className="sports_btn2"
                          onClick={() => onSetMoney(500000)}
                        >
                          50만원
                        </span>
                      </a>
                    </td>
                    <td width="33.3333%" align="center">
                      <a>
                        <span
                          className="sports_btn2"
                          onClick={() => onSetMoney(1000000)}
                        >
                          100만원
                        </span>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td width="33.3333%" align="center">
                      <a>
                        <span
                          className="sports_btn2"
                          onClick={() => onSetMoney("max")}
                        >
                          MAX
                        </span>
                      </a>
                    </td>
                    <td width="33.3333%" align="center">
                      <a>
                        <span
                          className="sports_btn2"
                          onClick={() => onSetMoney("min")}
                        >
                          Min
                        </span>
                      </a>
                    </td>
                    <td width="33.3333%" align="center">
                      <a>
                        <span className="sports_btn2" onClick={() => onReset()}>
                          전체지우기
                        </span>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td width="100%" colSpan="3" align="center">
                      <a onClick={onBetting}>
                        <span className="sports_btn1">베팅하기</span>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <span
        className="fade_1_open cart_open"
        data-popup-ordinal="0"
        id="open_39934871"
        onClick={() => onShowCard()}
      >
        <a>
          <img src="../images/m_cart.png" width="50" alt="" style={{opacity : '0.5'}}/>
        </a>
        {type !== "minigame" && (
          <span className="cart_count2">{betList.length}</span>
        )}
      </span>

      <div
        className="dialog"
        style={{
          display: popup ? "flex" : "none",
          backgroundColor: !popup && "#00000000",
          transition: "0.5s",
          scale: popup ? "1" : "0"
        }}
      >
        <div className="container popup_color" style={{ display: "block" }}>
          <div className="padding-20 d-flex">
            <img
              src="../images/question.png"
              style={{ margin: "20px auto 0 auto" }}
              alt=""
            />
          </div>
          {/* <span style={{width: "100%", textAlign: 'center'}}>베팅을 진행하시겠습니까?</span> */}
          <div className="justify-center d-flex">
            <span style={{ width: "100%", textAlign: "center" }}>
              베팅을 진행하시겠습니까?
            </span>
          </div>
          <div className=" w-100 justify-content-center padding-15">
            <span className="popup-btn" onClick={DoBetting}>
              네
            </span>
            <span className="popup-btn" onClick={onBetting}>
              아니오
            </span>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  bet: state.bet,
  sportsList: state.sports.data,
  bet_setting: state.sports.bet_setting,
  levelBettingData: state.sports.levelBettingData,
  isAuthenticated: state.user.isAuthenticated,
  pageInfo: state.page.pageInfo,
  userdata: state.user.data,
  sportsList:state.sports.data,
  histories: state.more.histories,
  user: state.user,
  minigame: state.mini
});

export default connect(
  mapStateToProps,
  {
    DoBetting,
    DoMiniBetting,
    ClearBetStore,
    CancelBetting,
    RemoveOneBet,
    ClearMiniBetStore,
    GetBettingHistories
  }
)(SportsRight);



// WEBPACK FOOTER //
// ./src/components/sports/SportsRight.js